import classNames from 'classnames';

import InternalLink from '@/components/InternalLink';
import ProductCard from '@/components/ProductCard';

import { Product } from '../../types/product';

import styles from './styles.module.scss';

interface SimilarProductsProps {
  products: Product[];
  title: string;
  isGalleryOpen: boolean;
  link: string;
  className?: string;
}

/**
 * Similar products section
 * @param param
 * @returns
 */
export const SimilarProducts = ({
  products,
  title,
  isGalleryOpen,
  link,
  className,
}: SimilarProductsProps) => {
  if (!products.length) {
    return null;
  }

  return (
    <section className={styles.skeletonSection}>
      <section
        className={classNames(className, {
          [styles.hidden]: isGalleryOpen,
        })}
      >
        <p className={styles.headline}>{title}</p>
        <div className={styles.productsWrapper}>
          {products.map(product => (
            <ProductCard
              product={product}
              key={product.id}
              isParagraph={true}
            />
          ))}
        </div>
        <div className={styles.linkWrapper}>
          <InternalLink
            label="Zobacz wszystkie produkty"
            link={link}
            isUpperCase
          />
        </div>
      </section>
    </section>
  );
};
